import { render, staticRenderFns } from "./_game_id.vue?vue&type=template&id=558329de&scoped=true&"
import script from "./_game_id.vue?vue&type=script&lang=js&"
export * from "./_game_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558329de",
  null
  
)

export default component.exports